import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseHoldVisitChartsDataContext } from './hooks/useHouseHoldVisitChartsDataContext';

export const EvolutionByHouseHoldStatus = () => {
    const { chartData } = useHouseHoldVisitChartsDataContext();

    return (
        <SimpleBars
            title={'Características do Paciente Acompanhado (5 maiores)'}
            horizontal={true}
            subtitles={chartData?.evolutionByHouseHoldStatus?.map(
                (item) => item.description
            )}
            values={chartData?.evolutionByHouseHoldStatus?.map(
                (item) => item.total || 0
            )}
        />
    );
};
